import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Platform } from '@angular/cdk/platform';
import { HandlerService } from './handler.service';
let ads;
@Injectable({
  providedIn: 'root'
})
export class AdsFetchService {
  allAds:any=[];
  dumAds:any=[];
  localAds:any=[];
  constructor(private service:ApiService,private sanitizer:DomSanitizer, public platform:Platform,public handler: HandlerService) { }
  getAds(){
    let deviceId;
    if (this.platform.ANDROID || this.platform.IOS) {
      deviceId=1;
    }
    else{
      deviceId=2;
    }
    this.service.getOrgForAdsSpace(deviceId).subscribe((res:any)=>{
      if(res){
        ads= res.filter(ads=>ads.adType==2)
        this.dumAds= res.filter(ads=>ads.adType==2);
        ads.map((data:any)=>{
          if(data.documentId)
          this.getAdById(data)
        })
      }else{
        this.handler.res("No Ads Found")
      }
    })
  }
  
  getAdById(data){
    let dur;
    if(data.duration)
    dur=data.duration
    else
    dur=5
  this.service.getDocument(data.documentId).subscribe(res=>{
  if(res!=null){
   let binary = new Uint8Array(res)
   let blob = new Blob([binary], { type: 'image/jpeg' });
   this.blobToBase64(blob,data.contentUrl)
   let img = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob))
   this.allAds.push({poster:img,url:data.contentUrl,duration:dur})
  }
  })
  }

  blobToBase64(blob,url){
    console.log(blob)
    var reader = new FileReader();
    reader.readAsDataURL(blob); 
    let obj = this
    reader.onloadend = function() {
    var base64data = reader.result;                
    obj.localAds.push({poster:base64data,url:url});
    localStorage.setItem('ads',JSON.stringify(obj.localAds));
    }
  }

}
